import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import queryString from "query-string";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useUser } from "@dreamchimney/user-context";
import SleevesByUserContainer from "~/Components/Containers/SleevesByUserContainer";
import SleeveMini from "~/Components/SleeveMini";
import Pager from "../../Components/Global/Pager";

const UserPage = ({ match, location }) => {
  let history = useHistory();
  const { state: userState, dispatch } = useUser();

  const chimdir = match.params.chimdir;
  const queryStringParams = queryString.parse(location.search);
  const { page: startPage = 1 } = queryStringParams;
  const [page, setPage] = useState(parseInt(startPage, 10));
  const updatePageCallBack = (toPage) => {
    history.push("?page=" + page);
    setPage(toPage);
  };
  const sleevesOwner = userState.user.dir === chimdir;
  return (
    <div className="page-user">
      <SleevesByUserContainer
        chimDir={chimdir}
        page={page}
        render={({ result }) => {
          const { sleeves, perPage, total, chim } = result;
          const pages = Math.ceil(total / perPage);

          if (sleeves.length === 0) return null;
          return (
            <React.Fragment>
              <Helmet>
                <title>Sleevery | {chim.full_name} Chimney | Dream Chimney</title>
              </Helmet>
              <Row>
                <Col xs={12}>
                  <h1 className="page-header">
                    <span style={{ marginRight: "10px" }}>
                      <i className="fa fa-tags"></i>
                    </span>

                    {sleevesOwner && `My Sleeves`}
                    {!sleevesOwner && `Sleeves from: ${chim.full_name} Chimney`}
                  </h1>
                </Col>
                <Col xs={12}></Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <ul className="results cover-wall">
                    {sleeves.map((sleeve) => (
                      <li key={sleeve.id}>
                        <SleeveMini sleeve={sleeve} />
                      </li>
                    ))}
                  </ul>
                </Col>

                <Col xs={12}>
                  <div style={{ padding: "20px 0" }}>
                    <Pager className="pagination-footer" page={page} pages={pages} updatePage={updatePageCallBack} />
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          );
        }}
      />
    </div>
  );
};

export default UserPage;
